import Vue from 'vue'
import { PiniaVuePlugin, createPinia } from 'pinia'
import VueRouter from 'vue-router'
import { HeadVuePlugin, createHead } from '@vueuse/head'
import 'uno.css'
import PortalVue from 'portal-vue'
import VConsole from 'vconsole'
import router from '@/router'
import App from '@/App.vue'
import { STORAGE_DEBUG } from '@/constants'
import { initTrack } from '@/track'

// msw mocks
if (import.meta.env.MODE === 'development') {
  const { worker } = await import('./mocks/browser')
  worker.start({
    onUnhandledRequest(req, print) {
      const url = new URL(req.url)
      if (url.pathname.startsWith('/src'))
        return

      print.warning()
    },
  })
}

// Note: current use `px`
// import '@/libs/flexible'

Vue.config.productionTip = false

// Pinia
const pinia = createPinia()
Vue.use(PiniaVuePlugin)

// Head
const head = createHead()
Vue.use(HeadVuePlugin)

// Router
Vue.use(VueRouter)

// Portal
Vue.use(PortalVue)

// Ignore custom elements
Vue.config.ignoredElements = ['wx-open-subscribe']

try {
  // Sentry, TODO:
  initTrack()
}
catch {}

if (import.meta.env.MODE !== 'production' || window.localStorage.getItem(STORAGE_DEBUG)) {
  // eslint-disable-next-line no-new
  new VConsole()
}

new Vue({
  router,
  pinia,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  head,
  render: h => h(App),
}).$mount('#app')
